import { Injectable } from '@angular/core';
import {
  IPagedItemsProceedResult,
  ServerSidePagedItemsProviderService,
  PagingApiMapperHelper,
} from '@core/data-providers';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ISendGridResponseSpam } from '@project/view-models';
import { SendGridApiProviderService } from './api-providers/sendgrid-api-provider.service';
import { ISendgridFiltersParams } from './sendgrid-bounces-server-side-items-provider.service';

@Injectable()
export class SendGridSpamsServerSideItemsProviderService extends ServerSidePagedItemsProviderService<
  ISendGridResponseSpam,
  ISendgridFiltersParams,
  null
> {
  constructor(private sendgridApiProviderService: SendGridApiProviderService) {
    super();
  }

  protected getDefaultFilters(): Partial<ISendgridFiltersParams> {
    return {};
  }

  protected proceedPagedItemsLoading(page, itemsPerPage): Observable<IPagedItemsProceedResult<ISendGridResponseSpam>> {
    return this.sendgridApiProviderService
      .getAllSpamsPaged(page, itemsPerPage)
      .pipe(
        map((result) => PagingApiMapperHelper.mapPagingApiResponseToProceedResult<ISendGridResponseSpam>(page, result)),
      );
  }
}
